import { userApi } from '@/lib/features/user/userApi'
import type { Middleware } from '@reduxjs/toolkit'
import { isRejectedWithValue, MiddlewareAPI } from '@reduxjs/toolkit'

export const rtkErrorHandler: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = action.payload as
      | { status: number; data: { message: string } }
      | { status: string; error: string }
    console.log('error', error)

    if (error.status === 401) {
      console.log('401 Error! Signing out...')
      userApi.endpoints.signOut.initiate()(api.dispatch, api.getState, {})
    }

    console.error('data' in error ? error.data.message : error.error)
  }
  return next(action)
}
